// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1KljL","title":"ClientReferral_title__sRa8Z","itemText":"ClientReferral_itemText__3Qk1K"};